module.exports = __webpack_public_path__ + "static/media/remoteAuthTempNew.ece2582e.xlsx";